module.exports = __webpack_public_path__ + "static/media/progman_7.54381369.ico";